export enum NewsTypesId {
  SPOTLIGHT = 0,
  LATEST = 1,
  COMPANY = 2,
}

export enum NewsTypes {
  SPOTLIGHT = 'spotlight',
  LATEST = 'latest',
  COMPANY = 'company',
}

export type NewsType = NewsTypes.SPOTLIGHT | NewsTypes.COMPANY | NewsTypes.LATEST;

export interface NewsTypeOption {
  id: number;
  code: NewsType;
  label: string;
}

export const newsTypeList: NewsType[] = [
  NewsTypes.COMPANY,
  NewsTypes.LATEST,
];

export const newsTypeOptions: NewsTypeOption[] = [
  {
    id: NewsTypesId.SPOTLIGHT,
    code: NewsTypes.SPOTLIGHT,
    label: '最新消息',
  },
  {
    id: NewsTypesId.LATEST,
    code: NewsTypes.LATEST,
    label: '活動快訊',
  },
  {
    id: NewsTypesId.COMPANY,
    code: NewsTypes.COMPANY,
    label: '公司動態',
  },
];
